import React from 'react';
import { Button } from '../ui/button';
import { ArrowRight, ExternalLink } from 'lucide-react';

const ProductsSection = () => {
  const products = [
    {
      name: "Vestido Midi Marrón Estampado",
      brand: "TRUCCO",
      originalPrice: "57,81 €",
      salePrice: "23,81 €",
      discount: "-34,00 €",
      image: "https://images.unsplash.com/photo-1752794966299-1fd0ccade152?crop=entropy&cs=srgb&fm=jpg&w=600&q=85",
      link: "https://styleoutlet.es/vestidos-trucco/66-198-trucco-vestido-midi-marron-estampado",
      tagline: "Elegancia para cualquier ocasión"
    },
    {
      name: "Abrigo Beige Estampado Acolchado",
      brand: "TRUCCO",
      originalPrice: "106,61 €",
      salePrice: "43,56 €",
      discount: "-63,05 €",
      image: "https://images.unsplash.com/photo-1592327877233-90b9bfd92e48?crop=entropy&cs=srgb&fm=jpg&w=600&q=85",
      link: "https://styleoutlet.es/abrigos-chaquetas-trucco/88-242-trucco-abrigo-beige-estampado-acolchado",
      tagline: "Estilo sofisticado y atemporal"
    },
    {
      name: "Vestido Verde Oliva Punto Midi",
      brand: "TRUCCO",
      originalPrice: "66,07 €",
      salePrice: "32,07 €",
      discount: "-34,00 €",
      image: "https://images.unsplash.com/photo-1733832193883-8880a8551424?crop=entropy&cs=srgb&fm=jpg&w=600&q=85",
      link: "https://styleoutlet.es/vestidos-trucco/149-370-trucco-vestido-verde-oliva-punto-midi",
      tagline: "Comodidad y estilo diario"
    },
    {
      name: "Abrigo Beige Corto Texturizado",
      brand: "NAELLE",
      originalPrice: "66,07 €",
      salePrice: "32,07 €",
      discount: "-34,00 €",
      image: "https://images.unsplash.com/photo-1623577840329-201565179c92?crop=entropy&cs=srgb&fm=jpg&w=600&q=85",
      link: "https://styleoutlet.es/abrigos-chaquetas-naelle/195-485-naelle-abrigo-beige-corto-texturizado",
      tagline: "Versatilidad premium"
    }
  ];

  return (
    <section data-testid="products-section" className="section-padding bg-white">
      <div className="container-custom">
        {/* Header */}
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="text-sm font-sans tracking-[0.2em] uppercase text-[#C8A96A] mb-4 block">
            Selección Premium
          </span>
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-[#111111] mb-4">
            Productos estrella
          </h2>
          <p className="text-lg font-sans text-[#111111]/70">
            Las prendas más deseadas de nuestra colección
          </p>
        </div>

        {/* Products Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {products.map((product, index) => (
            <a 
              key={index}
              href={product.link}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`product-card-${index}`}
              className="group product-card cursor-pointer"
            >
              <div className="relative overflow-hidden bg-[#F8F6F4] aspect-[3/4] mb-4">
                {/* Discount Badge */}
                <div className="absolute top-4 left-4 bg-[#C8A96A] text-white px-3 py-1 z-10">
                  <span className="text-sm font-bold">{product.discount}</span>
                </div>

                {/* Product Image */}
                <div className="w-full h-full flex items-center justify-center p-8 img-zoom">
                  <img
                    src={product.image}
                    alt={product.name}
                    className="max-w-full max-h-full object-contain transition-transform duration-500 group-hover:scale-105"
                    onError={(e) => {
                      e.target.src = "https://images.unsplash.com/photo-1625720361484-793445076bf1?crop=entropy&cs=srgb&fm=jpg&w=400&q=80";
                    }}
                  />
                </div>

                {/* Hover Overlay */}
                <div className="product-overlay absolute inset-0 bg-[#111111]/60 flex items-center justify-center">
                  <span className="bg-white text-[#111111] px-6 py-3 font-bold text-sm tracking-wider uppercase flex items-center gap-2">
                    Ver producto
                    <ExternalLink className="w-4 h-4" />
                  </span>
                </div>
              </div>

              {/* Product Info */}
              <div className="text-center">
                <span className="text-xs font-sans tracking-[0.15em] uppercase text-[#C8A96A] mb-2 block">
                  {product.brand}
                </span>
                <h3 className="font-serif text-lg text-[#111111] mb-2 group-hover:text-[#C8A96A] transition-colors line-clamp-2">
                  {product.name}
                </h3>
                <div className="flex items-center justify-center gap-3 mb-2">
                  <span className="font-sans font-bold text-xl text-[#111111]">
                    {product.salePrice}
                  </span>
                  <span className="font-sans text-sm text-[#8A8A8A] line-through">
                    {product.originalPrice}
                  </span>
                </div>
                <p className="text-sm font-sans text-[#8A8A8A] italic">
                  {product.tagline}
                </p>
              </div>
            </a>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center">
          <a 
            href="https://styleoutlet.es/28-top-ventas" 
            target="_blank" 
            rel="noopener noreferrer"
            data-testid="products-cta"
          >
            <Button className="bg-[#C8A96A] hover:bg-[#111111] text-white px-10 py-6 text-base font-bold tracking-widest uppercase transition-all duration-300 cursor-pointer">
              Ver todos los productos
              <ArrowRight className="ml-2 w-5 h-5" />
            </Button>
          </a>
        </div>
      </div>
    </section>
  );
};

export default ProductsSection;
